import { createSlice } from "@reduxjs/toolkit";
import {
  getUsers,
  addUser,
  updateUser,
  deleteUser,
} from "./actions/userActions";

const initialState = {
  webUser: null,
  webUsers: null,
  totalWebUsers: 0,
  mobileUser: null,
  mobileUsers: null,
  totalMobileUsers: 0,
  loading: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setWebUser: (state, action) => {
      const user = state.webUsers.find((_user) => _user.id === action.payload);
      state.webUser = user;
    },
    setMobileUser: (state, action) => {
      const user = state.mobileUsers.find(
        (_user) => _user.id === action.payload
      );
      state.mobileUser = user;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        const { data, isMobileUser } = action.payload;
        state.loading = false;
        if (isMobileUser === "yes") {
          state.mobileUsers = data.data;
          state.totalMobileUsers = data.count;
        } else {
          state.webUsers = data.data;
          state.totalWebUsers = data.count;
        }
      })
      .addCase(getUsers.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        const { type } = action.payload;
        state.loading = false;
        window.location.hash = `#/profile/user?type=${type}`;
      })
      .addCase(addUser.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        const { data, isMobileUser } = action.payload;
        state.loading = false;
        state.isEditing = false;
        if (isMobileUser === "yes") {
          state.mobileUser = data;
        } else {
          state.webUser = data;
        }
      })
      .addCase(updateUser.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.loading = false;
        window.location.hash = "#/profile/user?type=web";
      })
      .addCase(deleteUser.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setWebUser, setMobileUser, setIsEditing } = userSlice.actions;

export default userSlice.reducer;
